import React from "react";
import { Helmet } from "react-helmet";
import { useLocation, matchPath, useHistory } from "react-router-dom";
import { Breadcrumbs } from "@skyportal/ui-kit";
import { makeTitleFromBreadCrumbs } from "./utils";
import { getBreadCrumbsConfig } from "./config";

const ModuleBreadCrumbs = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const configItem = getBreadCrumbsConfig().find((item) => matchPath(pathname, item.match));

  if (!configItem) {
    return null;
  }

  const documentTitle = makeTitleFromBreadCrumbs(configItem);

  return (
    <>
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>
      <Breadcrumbs config={configItem} onBreadcrumbClick={history.push} />
    </>
  );
};

export default ModuleBreadCrumbs;
